import globalModule from "@/store/modules/global.module";
import RestClient from "../rest.client";
import IGeofence from "@/models/dto/IGeofence";

export default class GeofenceService {
    static async delete(geofenceId: number) {
        return await RestClient.call({
            url: `/geofences/${geofenceId}`,
            method: 'delete',
        })
    }

    static async getAll() {
        return await RestClient.call({
            url: `/geofences`,
            method: 'get',
        })
    }

    static async create(geofence: Partial<IGeofence>) {
        return await RestClient.call({
            url: '/geofences',
            method: 'post',
            data: geofence,
            headers: { 'Authorization': localStorage.getItem('token') }
        })
    }

}
